import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Inr from '@/components/Inr/index.vue';
import { getOrdersTransactions } from '@/api/orders-transactions';
import { getQuery } from '@/utils';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.listLoading = true;
    this.list = [];
    this.tableKey = 0;
  }
  created() {
    this.getList(this.orderId);
  }
  activated() {
    this.getList(this.orderId);
  }
  async getList(id) {
    try {
      this.listLoading = true;
      const data = await getOrdersTransactions(getQuery({
        sort: 'id,DESC',
        orderId: this.orderId,
        filter: {
          orderId: '$eq'
        }
      }));
      this.list = data;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
};
__decorate([Prop({
  default: null
})], default_1.prototype, "orderId", void 0);
default_1 = __decorate([Component({
  name: 'OrdersTransactionTab',
  components: {
    Inr
  }
})], default_1);
export default default_1;